// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PatientInformation from './data'

export default function PatientInformationFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PatientInformation">
      <PatientInformation {...props}>
        {children}
      </PatientInformation>
    </Flow>
  )
}
